// extracted by mini-css-extract-plugin
export default {"input":"Jaa-z","button":"Kaa-z","selected":"Laa-z","unavailable":"Maa-z","oos":"Naa-z","image":"Oaa-z","paperCutDisabledOverlay":"Paa-z"};